module.exports = __webpack_public_path__ + "static/img/example_fbrx.4d21fe0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/example_fbrx.jpg
// module id = 9//x
// module chunks = 128